module.exports = __webpack_public_path__ + "static/media/bi.91d9c68a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bi.svg
// module id = 65
// module chunks = 0